module.exports = __webpack_public_path__ + "static/img/移动应用.4aed3284.png";